import React from 'react'
import {Link} from 'react-router-dom'

import {Logo} from '../../logo'
import {Brand, Lang} from '../../logo/types'

export type Props = {
  lang?: Lang
  brand?: Brand
  isExternalLink?: boolean
}

const HeaderLogo: React.FC<Props> = ({isExternalLink, brand = 'yandex', lang = 'ru'}) => {
  if (isExternalLink) {
    return <Logo aria-label="На главную" brand={brand} component="a" href="/" lang={lang} />
  }

  return <Logo aria-label="На главную" brand={brand} component={Link} lang={lang} to="/" />
}

export default HeaderLogo
